// extracted by mini-css-extract-plugin
module.exports = {"breakpoint-desktop":"(min-width: 992px)","loyaltyTotal":"LoyaltyTotal-module--loyaltyTotal--faeeb2","logoButton":"LoyaltyTotal-module--logoButton--1ef90d"};